export default __webpack_public_path__ + "static/media/keyboard_key_5.28c82fd5.png";